import {get} from '../http';

const fetchApps = user => get(process.env.VUE_APP_BOOKMARKS_API_URL+'/essentials?user='+user);

export default {
  fetchApps
};
